'use client'

import CaseStudyCards from '@/app/newlp/CaseStudyCards'
import HBServices from '@/components/home-builders/HBServices'
import HBFaq from '@/components/home-builders/HBFaq'
import HBPurchaseNotice, { type PlaybookPurchaseNotice } from '@/components/home-builders/HBPurchaseNotice'
import WhitelabelCTA from '@/components/services/WhitelabelCTA'
import homeBuilderCases from '@/data/home-builder-cases.json'

export default function HomeBuildersMarketingPage({
  purchaseNotice,
}: {
  purchaseNotice?: PlaybookPurchaseNotice | null
}) {
  return (
    <div className="font-sans bg-[#f5f7fb] text-[#0a1628] overflow-x-hidden">
      {purchaseNotice ? <HBPurchaseNotice notice={purchaseNotice} /> : null}
      <div className="bg-white lg:px-16">
        <CaseStudyCards
          ctaHref="#get-quote"
          bgSrc="/images/home-builders/new-hero.webp"
          
          badgeLabel="For Home Builders"
          badgeIcon="home"
          cases={homeBuilderCases}
          heading="One stop for home builder"
          headingEm="marketing, CRM, AI systems."
          headingInline
          sub="I build the marketing, CRM, follow-up, and attribution systems that move home buyers from inquiry to signed contract."
          ctaLabel="Get a Project Quote"
          tags={['AI widgets', 'Model tours', 'Community pages', 'Builder playbooks', 'CRM setup', 'Attribution fix', 'Ads & SEO', 'AI workflows']}
          trustLabel="I set up and run these CRMs"
          trustLogos={[
            { name: 'Lasso', src: '/images/home-builders/lasso.png' },
            { name: 'Follow Up Boss', src: '/images/home-builders/fub.png' },
            { name: 'HubSpot', src: '/images/logo-hubspot.svg' },
            { name: 'Salesforce', src: '/images/logo-salesforce.svg' },
            { name: 'Buildertrend', src: '/images/home-builders/buildertrend.png' },
            { name: 'JobTread', src: '/images/logo-jobtread.png' },
            { name: 'Zoho CRM', src: '/images/logo-zoho.png' },
          ]}
        />
      </div>
      <HBServices />
      <HBFaq />
      <div className="hb-connect-cta">
        <WhitelabelCTA
          variant="classic"
          showFooter
          hideStats
          formSource="home-builders-lp"
          serviceName="Home Builder Systems"
        />
      </div>
    </div>
  )
}
